import { LayerWidget } from "./filters/layerWidget.js";
import { Camera } from '../../GL/scene/camera.js';
import { PhotoshopController } from '../../photoshopController.js';
import { GLEngine } from "../../GL/engine.js";
export class ImageWidget extends LayerWidget {
    imageSrc: HTMLElement | null;
    layerName: HTMLElement | null;

    constructor(parent: HTMLElement, layer, engine: GLEngine, camera: Camera, operation, controller: PhotoshopController) {
        super(parent, layer, engine, camera, operation, controller);
    }


    initEvent() {
        const eyeElem = document.getElementById("image-eye-" + this._widgetUniqueId);
        if (eyeElem) {
            eyeElem.addEventListener("click", this.image_eyeOnClick.bind(this));
        }
        const selectedElem = document.getElementById("image-selected-" + this._widgetUniqueId);
        if (selectedElem) {
            selectedElem.addEventListener("click", this.image_selected.bind(this));
        }
        const closeElem = document.getElementById("image-close-" + this._widgetUniqueId);
        if (closeElem) {
            closeElem.addEventListener("click", this.image_close.bind(this));
        }
    }

    deleteEvents() {
        const eyeElem = document.getElementById("image-eye-" + this._widgetUniqueId);
        if (eyeElem) {
            eyeElem.removeEventListener("click", this.image_eyeOnClick);
        }
        const selectedElem = document.getElementById("image-selected-" + this._widgetUniqueId);
        if (selectedElem) {
            selectedElem.removeEventListener("click", this.image_selected);
        }
        const closeElem = document.getElementById("image-close-" + this._widgetUniqueId);
        if (closeElem) {
            closeElem.removeEventListener("click", this.image_close);
        }
    }

    header() {
        return `
        <div id="image-activeLayer-` + this._widgetUniqueId + `" class="col s12 layer">
            <div class="col center-align" style="float: left;">
                <i id="image-eye-` + this._widgetUniqueId + `"class="fas"></i>
            </div>
        `;
    }

    html() {
        return this.header() + `
        <div id="image-selected-` + this._widgetUniqueId + `"style="cursor: pointer;">
            <img id="image-image-`+ this._widgetUniqueId + `" height="40px" class="col" style="float: left; margin-top: 4px;" />
            <div id="image-name-`+ this._widgetUniqueId + `" style="overflow: hidden; text-overflow: ellipsis;"></div> 
        </div>
        ` + this.footer();
    }

    footer() {
        return `
        <div style="position: absolute; top: -12px; right: 4px;">
            <i id="image-close-` + this._widgetUniqueId + `"class="far fa-trash-alt"></i>
        </div>
        </div>
        `;
    }

    image_eyeOnClick() {
        this.controller.touch();
        this.layer.enable = !this.layer.enable;
        this.updateClass();
        this.controller.update();
    }

    image_selected() {
        if (!this.controller.PSEngine) {
            return;
        }
        this.controller.PSEngine.activeLayer = this.layer;
        this.controller.photoshopWidget.dataPanelWidget.layersWidget.updateClass();
    }

    image_close() {
        this.deleteEvents();
        super.destroyLayer();
    }

    updateClass() {
        if (this.layer === this.controller.PSEngine?.activeLayer) {
            const activeLayerElem = document.getElementById("image-activeLayer-" + this._widgetUniqueId);
            if (activeLayerElem) {
                activeLayerElem.classList.add('selected');
            }
        } else {
            const activeLayerElem = document.getElementById("image-activeLayer-" + this._widgetUniqueId);
            if (activeLayerElem) {
                activeLayerElem.classList.remove('selected');
            }
        }
        if (this.layer.enable) {
            const eyeElem = document.getElementById("image-eye-" + this._widgetUniqueId);
            if (eyeElem) {
                eyeElem.classList.add('fa-eye');
            }
        } else {
            const eyeElem = document.getElementById("image-eye-" + this._widgetUniqueId);
            if (eyeElem) {
                eyeElem.classList.remove('fa-eye');
            }
        }
        if (!this.layer.enable) {
            const eyeElem = document.getElementById("image-eye-" + this._widgetUniqueId);
            if (eyeElem) {
                eyeElem.classList.add('fa-eye-slash');
            }
        } else {
            const eyeElem = document.getElementById("image-eye-" + this._widgetUniqueId);
            if (eyeElem) {
                eyeElem.classList.remove('fa-eye-slash');
            }
        }
        this.imageSrc = document.getElementById("image-image-" + this._widgetUniqueId);
        if (this.imageSrc instanceof HTMLImageElement) {
            this.imageSrc.src = this.layer.image.src;
        }
        this.layerName = document.getElementById("image-name-" + this._widgetUniqueId);
        if (this.layerName) {
            this.layerName.textContent = this.layer.name;
        }
    }
}